/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { AxiosError, AxiosResponse } from 'axios';
import axiosConfig, { ApiRequestType } from 'axiosConfig/axiosConfig';
import { SanctioningBodyResponse } from 'models/viewModels';

class SanctioningBodyApi {
  async getSanctioningBodies(): Promise<SanctioningBodyResponse> {
    return new Promise<SanctioningBodyResponse>((resolve, reject) => {
      axiosConfig(ApiRequestType.MotorsportsCompToolsApi)
        .post('/rest/session/sanctioningBodies')
        .then((res: AxiosResponse<SanctioningBodyResponse>) => resolve(res.data))
        .catch((error: AxiosError) => reject(new AxiosError(error.message, error.code)));
    });
  }
}

export const sanctioningBodyApi = new SanctioningBodyApi();
